export default "__VITE_ASSET__BVJE5OG1__"